export { default as AuthRoute } from './AuthRoute';
export { default as AnimRoute } from './AnimRoute';


// WEBPACK FOOTER //
// ./src/components/routes/index.js